module.exports = __webpack_public_path__ + "img/ic-report.cb8aa126.png";